import { Box, Flex, Text, Collapse } from "@chakra-ui/react";
import { useState, memo, useEffect } from "react";
import colors from "core/resources/theme/colors";
import { BiChevronDown, BiChevronRight } from "react-icons/bi";
import TableRelatorioUnidades from "./../RelatorioUnidadesTable/index";
import { RelatorioUnidadesPaginadoItem } from "core/features/relatorios/typings/index";
import useRelatorioUnidadesPessoas from "core/features/relatorios/hooks/useRelatorioUnidadesPessoas";

export interface ItemUnidadeProps {
  item: RelatorioUnidadesPaginadoItem;
}

function ItemUnidade({ item }: ItemUnidadeProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(false);
  const { data, isLoading } = useRelatorioUnidadesPessoas(
    item.unidadeId,
    shouldLoad
  );

  useEffect(() => {
    if (isOpen) {
      setShouldLoad(true);
    }
  }, [isOpen]);
  const toggle = () => setIsOpen((state) => !state);
  return (
    <Box>
      <Flex
        cursor="pointer"
        bg={colors.lightBlue}
        onClick={toggle}
        py={1}
        pr={6}
        pl={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom={`1px solid ${colors.gray}`}
      >
        <Flex alignItems="center" h="40px">
          <Flex>
            {isOpen ? (
              <BiChevronDown size={25} color={colors.black700} />
            ) : (
              <BiChevronRight size={25} color={colors.black700} />
            )}
          </Flex>
          <Text ml={1} fontWeight="medium" fontSize="16px">
            Unidade {item.unidade}
          </Text>
        </Flex>
        <Flex>
          <Text ml={16} fontWeight="medium" fontSize="16px" w={"95px"}>
            Fração: {item.fracao ?? "--"}
          </Text>
          <Text ml={16} fontWeight="medium" fontSize="16px" w={"95px"}>
            Peso: {item.peso ?? "--"}
          </Text>
          <Text ml={16} fontWeight="medium" fontSize="16px" w={"135px"}>
            Área privativa: {item.area !== null ? `${item.area} m²` : "--"}
          </Text>
          <Text ml={16} fontWeight="medium" fontSize="16px" w={"135px"}>
            Área construída:{" "}
            {item.areaConstruida !== null ? `${item.areaConstruida} m²` : "--"}
          </Text>
        </Flex>
      </Flex>
      <Collapse in={isOpen}>
        <Box>
          <TableRelatorioUnidades
            pessoas={data?.pessoas ?? []}
            isLoading={isLoading}
          />
        </Box>
      </Collapse>
    </Box>
  );
}

export default memo(ItemUnidade);
